import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	"components": {
		"app": {
			"children": {
				"wrapper": {
					"min": {
						"height": "500px"
					},
					"position": "relative"
				},
				"loadingWrapper": {
					"position": "absolute",
					"top": "0px",
					"bottom": "0px",
					"left": "0px",
					"right": "0px",
					"background": {
						"color": "white"
					}
				}
			}
		}
	},
	"theme": {}
};